exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{height:100%}body{background:#f0f0f0;min-height:100%;overflow-y:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/App.css
// module id = 404
// module chunks = 0